import MxAlertIcon from '@rf-l1/alert/MxAlertIcon'
import MxEmptyBody from '@rf-l1/empty-sections/MxEmptyBody'
import MxEmptyCard from '@rf-l1/empty-sections/MxEmptyCard'
import MxEmptyLabel from '@rf-l1/empty-sections/MxEmptyLabel'
import React from 'react'

const MxListErrorTemplate = () => {
  return (
    <MxEmptyCard size='section'>
        <MxAlertIcon type='info'/>      
        <MxEmptyBody>
            Ah ocurrido un error
        </MxEmptyBody>
    </MxEmptyCard>
  )
}

export default MxListErrorTemplate